import { createFieldSelectorHook } from 'src/lib/sweetState';

import Store from './Store';

export default createFieldSelectorHook(Store, 'currentUser');
